class productStickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.mainButton = document.querySelector("[data-track-add-to-cart-main]");

    this.debouncedOnLoad = debounce((event) => {
      // when bottom is reached, hide the bar. Use math because it can return a half pixel...
      if (
        event.type === "scroll" &&
        window.innerHeight + Math.round(window.scrollY) >= document.body.offsetHeight
      ) {
        this.hideBar();
        return;
      }
      this.showBar(event);
    }, 50);

    // play video on scroll
    window.addEventListener("scroll", this.debouncedOnLoad.bind(this));

    // play video if it's visible on load
    window.addEventListener("load", this.debouncedOnLoad.bind(this));
  }

  showBar(event) {
    // Register IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const elementBounds = entry.boundingClientRect;
        const isBottomVisible = elementBounds.top <= 10;
        // display the bar when the ATC button is out of screen
        if (isBottomVisible) {
          this.classList.add("product__sticky-atc--visible");
        } else {
          this.hideBar();
        }
      });
    });
    // Declares what to observe, and observes its properties.
    observer.observe(this.mainButton);
  }

  hideBar() {
    this.classList.remove("product__sticky-atc--visible");
  }
}

if (!customElements.get("sticky-add-to-cart")) {
  customElements.define("sticky-add-to-cart", productStickyAddToCart);
}
